function moveAnimationWhenInView(){
  if ($(window).width() < 768) return; // スマホ無効

  var $targetBox = $('.randomBox');

  if ($targetBox.length === 0 || $targetBox.hasClass('play')) return;

  var boxTop = $targetBox.offset().top;
  var scroll = $(window).scrollTop();
  var windowHeight = $(window).height();

  if (scroll + windowHeight > boxTop + 50) {
    $targetBox.addClass('play');

    var items = Array.from($targetBox.children());

    function animateNext() {
      if (items.length === 0) return;
      var rnd = Math.floor(Math.random() * items.length);
      $(items[rnd]).addClass('fadeUp_2');
      items.splice(rnd, 1);
      setTimeout(animateNext, 500);
    }

    animateNext();
  }
}

$(window).on('load scroll resize', function(){
  moveAnimationWhenInView();
});
